







































































































































import Vue from 'vue'

import { Button } from '@raksul/raksul-common-ui'
import ModalOverlay from '@/common/components/ModalOverlay.vue'
import BaseImage from '@/common/components/BaseImage.vue'

import { SVG_PLACEHOLDER_IMAGES } from '@/common/constants'
import { SERVICES } from '@/stockLibrary/config/services'
import { CrossSellNamingEditor } from '@/stockLibrary/queries/types'
import DesignPreview from './DesignPreview.vue'

export default Vue.extend({
  components: { BaseImage, Button, DesignPreview, ModalOverlay },
  props: {
    namingEditors: {
      type: Array as () => CrossSellNamingEditor[],
      required: true
    },
    displayedDesign: {
      type: String,
      required: true
    },
    isLoggedIn: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    placeholder() {
      return SVG_PLACEHOLDER_IMAGES
    },
    services() {
      return SERVICES
    },
    defaultSimulatorImages(): string[] {
      return [
        '006.png',
        '007.png',
        '008.png',
        '009.png',
        '010.png',
        '011.png'
      ]
    }
  },
  methods: {
    closeModal() {
      this.$emit('close')
    }
  }
})
